import axios from "axios";
import SweetAlert from "sweetalert2";
import Data from "../Data/Data.json";
import { SimulationQardDto } from "../Models/SimulationQardDto";
import { DemandeQardDto } from "../Models/DemandeQardDto";

/**
 * Consomme l'API genTabamount avec un indicateur de chargement (Loader) pendant la requête
 */
export const PrintTabamortdemande = async (
  codUser: string,
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  LibPeriodicite:string,
  DemandeQard: DemandeQardDto , 
  format: string = "PDF"
) => {
  try {
    // 1. Affichage du Loader (Chargement en cours...)
    SweetAlert.fire({
      title: "Génération en cours",
      html: "Veuillez patienter pendant la création du tableau d'amortissement...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        SweetAlert.showLoading(); // Active le spinner d'attente
      }
    });

    // Formatage de la date pour l'API .NET (YYYY-MM-DD)
    const formattedDatePremEch = DemandeQard.DatePremEch instanceof Date 
      ? DemandeQard.DatePremEch.toISOString().split('T')[0] 
      : DemandeQard.DatePremEch;

    // 2. Envoi de la requête à l'API
    const response = await axios.get(
      Data.ApiUrl.RapportTabamortQard,
      {
        params: {
          NumeroDemande: DemandeQard.NumeroDemande,
          codAgce2: CodAgce2,
          libelle: Libelle,
          banque: Banque,
          teleph: Teleph,
          numReg: NumReg,
          licence: Licence,
          numCon: NumCon,
          bPoste: BPoste,
          ville: Ville,
          nomUser: NomUser,
          format: format.toUpperCase(),
        },
        responseType: "blob",
      }
    );

    // 3. Fermeture du loader initial avant d'afficher les options
    SweetAlert.close();

    if (response.data) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-");
      
      const fileName = `TabAmortissement_${DemandeQard.NumeroDemande}_${DemandeQard.Numcli}_${formattedDate}_${formattedTime}.${format.toLowerCase()}`;
      const fileUrl = URL.createObjectURL(blob);

      // 4. Boîte de dialogue d'action (Prévisualiser, Imprimer, Télécharger)
      SweetAlert.fire({
        title: "Tableau d'amortissement généré",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le document ?",
        icon: "success",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        if (result.isConfirmed) {
          // 🖥️ Prévisualiser
          window.open(fileUrl, "_blank");
        } else if (result.isDenied) {
          // 🖨️ Imprimer via Iframe
          const printHtml = `
            <html>
              <head>
                <title>${fileName}</title>
                <style>html, body { margin: 0; height: 100%; } iframe { width: 100%; height: 100%; border: none; }</style>
              </head>
              <body>
                <iframe id="pdfFrame" src="${fileUrl}"></iframe>
                <script>
                  const iframe = document.getElementById('pdfFrame');
                  iframe.onload = function() {
                    setTimeout(() => {
                      iframe.contentWindow.focus();
                      iframe.contentWindow.print();
                    }, 500);
                  };
                </script>
              </body>
            </html>
          `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else if (result.isDismissed && result.dismiss === SweetAlert.DismissReason.cancel) {
          // 💾 Télécharger
          const link = document.createElement("a");
          link.href = fileUrl;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage mémoire
        setTimeout(() => {
          URL.revokeObjectURL(fileUrl);
        }, 10000);
      });
    } else {
      throw new Error("Le serveur a renvoyé un fichier vide.");
    }
  } catch (error) {
    // En cas d'erreur, on ferme le loader et on affiche l'alerte d'erreur
    SweetAlert.close();
    console.error("Erreur lors de la génération du tableau d'amortissement :", error);
    SweetAlert.fire({ 
      title: "Erreur de génération", 
      text: "Impossible de récupérer le document. Veuillez réessayer.", 
      icon: "error" 
    });
  }
};